<div class="backdrop" (click)="doDismiss()">
  <div class="privacy-snack-bar-container" (click)="$event.stopPropagation()">
    <div class="text">
      <span class="detail">I agree to the <a href="https://www.huddyhealth.com/privacyPolicy" target="_blank">Terms and Conditions</a>.</span>
    </div>
    <div class="button">
      <button mat-button (click)="doAgree()">Agree</button>
    </div>
  </div>
</div>
